import { render, staticRenderFns } from "./TransferReceivedProductsModal.vue?vue&type=template&id=51dfca43&"
import script from "./TransferReceivedProductsModal.vue?vue&type=script&lang=js&"
export * from "./TransferReceivedProductsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports